<div [style.color]="(seoCategoryStyle$ | async)?.tintColor" [style.backgroundColor]="(seoCategoryStyle$ | async)?.backgroundColor">
    <h1 categoryPageStyles class="text-l ttu m-0 seo-category">
        {{ seoCategoryName }}
    </h1>
</div>
<ul
    class="grid-product-list grid-product-list-1"
    infiniteScroll
    categoryPageStyles
    [infiniteScrollDistance]="4"
    [infiniteScrollThrottle]="50"
    (scrolled)="onScrollStudio()"
>
    <li
        class="relative grid-product grid-product-view {{ 'template-' + element.template }}"
        *ngFor="let element of pageGridElements; let i = index"
        [style.color]="element?.style?.tintColor"
        [style.backgroundColor]="element?.style?.backgroundColor"
        [style.fill]="element?.style?.tintColor"
    >
        <category-debug
            *ngIf="(isDebugShowProductsInfoActive$ | async) === true"
            [info]="'Template: ' + element.template"
            [template]="'badget'"
        ></category-debug>

        <ng-container
            dynamicTemplateSelector
            [elementIndex]="i"
            [products]="element.ccIds"
            [templateName]="element.template"
            [categoryConfiguration]="categoryConfiguration$ | async"
            [elementDefaultImageTypes]="defaultImageTypes"
            [isMediaCarouselActivated]="showMediaCarousel"
            [defaultTemplateAttachment]="defaultTemplateAttachment"
            (clickAddToCart)="addToCartSheet($event)"
        >
        </ng-container>
    </li>
</ul>

@defer (when addToCartSheetModel; prefetch on idle) {
    @if (addToCartSheetModel) {
        <add-to-cart-bottom-sheet
            [sheetModel]="addToCartSheetModel"
            [productViewConfig]="productViewConfig"
            (closeSheet)="closeAddToCartSheet($event)"
        ></add-to-cart-bottom-sheet>
    }
}

@defer (on viewport) {
    @if (showLastSizesGrid) {
        <app-grid-last-sizes
            [category]="category"
            [isCategoryNew]="isCategoryNew"
            [defaultImageTypes]="defaultImageTypes"
            [gridType]="1"
            [showMediaCarousel]="showMediaCarousel"
            [templateConfiguration]="templateConfiguration"
        ></app-grid-last-sizes>
    }
} @placeholder {
    <div class="alterative-grids-container"></div>
}
